/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Something_Went_Wrong_TitleInputs */

const en_dialog_something_went_wrong_title = /** @type {(inputs: Dialog_Something_Went_Wrong_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something Went Wrong`)
};

const ar_dialog_something_went_wrong_title = /** @type {(inputs: Dialog_Something_Went_Wrong_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدث خطأ`)
};

const de_dialog_something_went_wrong_title = /** @type {(inputs: Dialog_Something_Went_Wrong_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist ein Fehler aufgetreten`)
};

const es_dialog_something_went_wrong_title = /** @type {(inputs: Dialog_Something_Went_Wrong_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se produjo un error`)
};

const fr_dialog_something_went_wrong_title = /** @type {(inputs: Dialog_Something_Went_Wrong_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur s’est produite`)
};

const it_dialog_something_went_wrong_title = /** @type {(inputs: Dialog_Something_Went_Wrong_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è verificato un errore`)
};

const ja_dialog_something_went_wrong_title = /** @type {(inputs: Dialog_Something_Went_Wrong_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラーが発生しました`)
};

const ko_dialog_something_went_wrong_title = /** @type {(inputs: Dialog_Something_Went_Wrong_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오류가 발생했어요`)
};

const pt_br_dialog_something_went_wrong_title = /** @type {(inputs: Dialog_Something_Went_Wrong_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado`)
};

const ru_dialog_something_went_wrong_title = /** @type {(inputs: Dialog_Something_Went_Wrong_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Произошла ошибка`)
};

const th_dialog_something_went_wrong_title = /** @type {(inputs: Dialog_Something_Went_Wrong_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกิดข้อผิดพลาด`)
};

const tr_dialog_something_went_wrong_title = /** @type {(inputs: Dialog_Something_Went_Wrong_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir hata oluştu`)
};

const zh_cn_dialog_something_went_wrong_title = /** @type {(inputs: Dialog_Something_Went_Wrong_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发生错误`)
};

const zh_tw_dialog_something_went_wrong_title = /** @type {(inputs: Dialog_Something_Went_Wrong_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發生錯誤`)
};

/**
* | output |
* | --- |
* | "Something Went Wrong" |
*
* @param {Dialog_Something_Went_Wrong_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_something_went_wrong_title = /** @type {((inputs?: Dialog_Something_Went_Wrong_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Something_Went_Wrong_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_something_went_wrong_title(inputs)
	if (locale === "ar") return ar_dialog_something_went_wrong_title(inputs)
	if (locale === "de") return de_dialog_something_went_wrong_title(inputs)
	if (locale === "es") return es_dialog_something_went_wrong_title(inputs)
	if (locale === "fr") return fr_dialog_something_went_wrong_title(inputs)
	if (locale === "it") return it_dialog_something_went_wrong_title(inputs)
	if (locale === "ja") return ja_dialog_something_went_wrong_title(inputs)
	if (locale === "ko") return ko_dialog_something_went_wrong_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_something_went_wrong_title(inputs)
	if (locale === "ru") return ru_dialog_something_went_wrong_title(inputs)
	if (locale === "th") return th_dialog_something_went_wrong_title(inputs)
	if (locale === "tr") return tr_dialog_something_went_wrong_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_something_went_wrong_title(inputs)
	return zh_tw_dialog_something_went_wrong_title(inputs)
});